
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { updateAllMetadata, getRouteMetadata, PageMetadata } from '../utils/dynamicMetadata';

/**
 * Hook for managing metadata updates when routes change or component metadata needs to be updated
 * @param customMetadata Optional custom metadata that overrides route defaults
 */
export function useMetadata(customMetadata?: PageMetadata) {
  const location = useLocation();
  const lastPathRef = useRef(location.pathname);
  const lastMetadataRef = useRef(customMetadata);
  
  useEffect(() => {
    // Don't update if nothing has changed
    if (
      location.pathname === lastPathRef.current && 
      JSON.stringify(customMetadata) === JSON.stringify(lastMetadataRef.current)
    ) {
      return;
    }
    
    // Update refs
    lastPathRef.current = location.pathname;
    lastMetadataRef.current = customMetadata;
    
    // Get default metadata for this route
    const routeMetadata = getRouteMetadata(location.pathname);
    
    // Merge with any custom metadata provided
    const finalMetadata = {
      ...routeMetadata,
      ...customMetadata
    };
    
    // Update all metadata tags
    updateAllMetadata(finalMetadata);
    
  }, [location.pathname, customMetadata]);
  
  return {
    updateMetadata: updateAllMetadata
  };
}
